import React from 'react';

const Summary = ({records}) => {
    // const manifestSum = JSON.parse(records.ManifestSummary)
    const summary = JSON.parse(records.Summary)
    return (
        <div>
            <table className="table table-striped table-hover">
                <tbody>
                    <tr>
                        <td style={{width: '30%'}}>Total Manifests</td>
                        <th>{summary['Total Manifests'] }</th>
                    </tr>
                    <tr>
                        <td>Total Passengers</td>
                        <th>{summary['Total Passengers'] }</th>
                    </tr>
                    <tr>
                        <td>Skipped Manifests </td>
                        <th>{summary['Skipped Manifests'] }</th>
                    </tr>
                    <tr>
                        <td>Successful Manifests </td>
                        <th>{summary['Successful Manifests'] }</th>
                    </tr>
                    <tr>
                        <td>Processed Tickets </td>
                        <th>{summary['Proccessed Tickets'] }</th>
                    </tr>
                    <tr>
                        <td>Duplicated Tickets </td>
                        <th>{summary['Duplicated Tickets'] }</th>
                    </tr>
                    <tr>
                        <td>Existing Tickets </td>
                        <th>{summary['Existing Tickets'] }</th>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Summary;



// WEBPACK FOOTER //
// ./src/views/uploadManifest/summary.js